import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=234c245e&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=234c245e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c245e",
  null
  
)

export default component.exports